<template>
  <div class="dashboard">
    <!-- 设备卡片区域：每行2个设备 -->
    <div class="device-card-grid">
      <div v-for="(device, idx) in deviceList"
           :key="device.devid"
           class="device-card-ui"
           :class="{ 'active': selectedDevice && selectedDevice.devid === device.devid }"
           @click="handleDeviceClick(device)">
        <div class="device-card-content">
          <div class="device-card-left">
            <div class="device-card-label-row">
              <img src="/img/icon-runtime.png"
                   class="device-label-icon-img"
                   alt="runtime icon" />
              <span class="device-label">设备总运行时间</span>
            </div>
            <div class="device-runtime-row">
              <span class="device-runtime-value">{{ device.runTime }}</span>
              <span class="device-runtime-unit">分钟</span>
            </div>
            <div class="device-status-row-ui">

              <span class="status-label-ui"> <span class="status-dot-ui"></span>实时监控</span>
              <span class="device-time-ui">{{ currentTime }}</span>
            </div>
            <div class="device-id-ui">设备编号：{{ device.devid }}</div>
          </div>
          <div class="device-card-right">
            <div class="device-img-wrap-ui">
              <img class="device-img-ui"
                   :src="getDeviceImg(device.devidName)"
                   :alt="device.devidName" />
            </div>
            <div class="device-name-ui">{{ device.devidName }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 监控卡片区：只显示选中设备的实时数据 -->
    <div v-if="selectedDevice"
         class="monitor-grid-5">
      <div v-for="(card, index) in statsCards"
           :key="index"
           class="monitor-card-5"
           :class="{ 'warning': isWarningValue(card) }"
           :style="{ background: card.gradient }">
        <div class="card-content card-content-new">
          <div class="card-header">
            <div class="card-icon">
              <img :src="card.img"
                   alt="icon"
                   class="card-icon-img" />
            </div>
            <div class="card-title">{{ card.title }}</div>
          </div>
          <div class="card-value">{{ card.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      currentTime: '',
      deviceList: [],
      selectedDevice: null, // 当前选中设备对象
      statsCards: [
        { title: '激光运行时间', value: 0, gradient: '#2ea2fa', img: '/img/time.png' },
        { title: '加工次数', value: 0, gradient: '#2ea2fa', img: '/img/process.png' },
        { title: '高温报警次数', value: 0, gradient: '#2ea2fa', img: '/img/temp_alarm.png' },
        { title: '水位报警次数', value: 0, gradient: '#2ea2fa', img: '/img/water_alarm.png' },
        { title: '开盖次数', value: 0, gradient: '#2ea2fa', img: '/img/cap.png' },
        { title: '水流状态', value: 0, gradient: '#2ea2fa', img: '/img/water_flow.png' },
        { title: '水温温度', value: 0, gradient: '#2ea2fa', img: '/img/water_temp.png' },
        { title: '吹气状态', value: 0, gradient: '#2ea2fa', img: '/img/wind.png' },
        { title: '激光功率', value: 0, gradient: '#2ea2fa', img: '/img/power.png' },
        { title: '激光切割仓温度', value: 0, gradient: '#2ea2fa', img: '/img/case_temp.png' },
      ],
      intervalId: null,
    }
  },
  methods: {
    getDeviceImg(name) {
      // 根据设备名称选择对应的图片
      if (name.includes('530')) {
        return '/img/light-530.png';
      } else if (name.includes('640')) {
        return '/img/light-640.png';
      } else if (name.includes('1390')) {
        return '/img/light-1390.png';
      } else if (name.includes('960')) {
        return '/img/light-960.png';
      } else if (name.includes('打标机')) {
        return '/img/打标机.png';
      } else if (name.includes('蓝光')) {
        return '/img/蓝光激光切割机.png';
      }
      // 默认图片
      return '/img/light-530.png';
    },
    async fetchData() {
      try {
        let institutionName = localStorage.getItem('userInstitutionName') || '中泽';
        // 去除空格和双引号
        institutionName = institutionName.trim().replace(/^\["']|["']$/g, '');
        // 确保 institutionName 进行了 URL 编码
        const encodedInstitutionName = encodeURIComponent(institutionName);
        const response = await axios.get(`/api/mqtt/selectAllByDevid?institutionName=${encodedInstitutionName}`);
        if (response.data.code === 200 && Array.isArray(response.data.data)) {
          // 处理设备列表数据
          const allDevices = [];
          response.data.data.forEach(item => {
            if (item.data && Array.isArray(item.data) && item.data.length > 0) {
              allDevices.push(...item.data);
            }
          });
          const oldSelectedId = this.selectedDevice ? this.selectedDevice.devid : null;
          this.deviceList = allDevices;
          // 实时刷新卡片数据，如果当前有选中设备，自动刷新 statsCards
          if (this.selectedDevice) {
            const latestDevice = allDevices.find(dev => dev.devid === this.selectedDevice.devid);
            if (latestDevice) {
              this.selectedDevice = latestDevice;
              this.updateStatsCards(latestDevice);
            } else {
              // 如果选中设备已不存在，自动选第一个
              if (allDevices.length > 0) {
                this.handleDeviceClick(allDevices[0]);
              } else {
                this.selectedDevice = null;
                this.updateStatsCards({}); // 清空卡片
              }
            }
          } else if (allDevices.length > 0) {
            this.handleDeviceClick(allDevices[0]);
          } else {
            this.selectedDevice = null;
            this.updateStatsCards({}); // 清空卡片
          }
        } else {
          console.error('数据加载失败或数据格式不正确:', response.data);
        }
      } catch (error) {
        console.error('请求接口失败:', error);
      }
    },
    isWarningValue(card) {
      // 根据不同类型的数据设置警告阈值
      if (card.title.includes('温度')) {
        return parseFloat(card.value) > 40;
      }
      if (card.title.includes('报警')) {
        return parseInt(card.value) > 0;
      }
      return false;
    },
    updateCurrentTime() {
      const now = new Date();
      this.currentTime = now.toLocaleTimeString();
    },
    handleDeviceClick(device) {
      this.selectedDevice = device;
      this.updateStatsCards(device);
    },
    updateStatsCards(data) {
      // 用选中设备的数据更新监控卡片
      for (let i = 0; i < this.statsCards.length; i++) {
        switch (i) {
          case 0:
            this.statsCards[i].value = (data.workTime || 0) + '分钟';
            break;
          case 1:
            this.statsCards[i].value = (data.processNum || 0) + '次';
            break;
          case 2:
            this.statsCards[i].value = (data.fireAlarmNum || 0) + '次';
            break;
          case 3:
            this.statsCards[i].value = (data.waterNum || 0) + '次';
            break;
          case 4:
            this.statsCards[i].value = ((data.capNum || 0)) + '次';
            break;
          case 5:
            this.statsCards[i].value = (data.waterStream || 0) + 'L/min';
            break;
          case 6:
            this.statsCards[i].value = (data.waterTemperature || 0) + '℃';
            break;
          case 7:
            this.statsCards[i].value = (data.wind === 0 ? '关闭' : '开启');
            break;
          case 8:
            this.statsCards[i].value = (data.power || 0) + '%';
            break;
          case 9:
            this.statsCards[i].value = (data.casetemperature || 0) + '℃';
            break;
          default:
            break;
        }
      }
    },
  },
  mounted() {
    this.updateCurrentTime();
    setInterval(this.updateCurrentTime, 1000);
    console.log('组件挂载，开始获取数据');
    // 首先获取设备列表
    this.fetchData();
    // 暂时注释掉定时器，方便调试
    this.intervalId = setInterval(() => this.fetchData(), 1000);
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding: 30px;
  background: #f6faff;
  min-height: 100vh;
  border-radius: 20px;
}
.device-card-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 18px;
  box-shadow: 0 2px 12px rgba(46, 162, 250, 0.05);
}
.device-card-ui {
  background: #f7fbfe;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(46, 162, 250, 0.12);
  flex: 1 1 calc(50% - 18px);
  min-width: 360px;
  max-width: 48%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  padding: 0;
  border: 2px solid #e3f1fc;
}
.device-card-ui.active {
  border: 2.5px solid #2ea2fa;
  box-shadow: 0 4px 18px rgba(46, 162, 250, 0.18);
}
.device-card-content {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  padding: 18px 18px 12px 24px;
}
.device-card-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.device-card-label-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.device-label-icon-img {
  width: 40px;
  height: 40px;
  margin-right: 6px;
  vertical-align: middle;
}
.device-label {
  font-size: 15px;
  color: #888;
}
.device-runtime-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 12px;
}
.device-runtime-value {
  font-size: 32px;
  color: #2ea2fa;
  font-weight: 600;
  margin-right: 4px;
}
.device-runtime-unit {
  font-size: 18px;
  color: #2ea2fa;
  font-weight: 500;
}
.device-status-row-ui {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.status-dot-ui {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #3ed96b;
  margin-right: 6px;
  z-index: 99;
  display: inline-block;
  animation: blink-dot 1.1s infinite alternate;
}
@keyframes blink-dot {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.35;
  }
}
.status-label-ui {
  font-size: 15px;
  color: #fff;
  background: #2ea2fa;
  border-radius: 18px;
  padding: 2px 16px 2px 12px;
  margin-right: 8px;
  font-weight: 500;
}
.device-time-ui {
  font-size: 15px;
  color: #fff;
  background: #2ea2fa;
  border-radius: 18px;
  padding: 2px 16px 2px 12px;
  margin-right: 0;
  font-weight: 500;
}
.device-id-ui {
  font-size: 14px;
  color: #333;
  margin-top: 4px;
  text-align: justify;
}
.device-card-right {
  width: 135px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}
.device-img-wrap-ui {
  width: 90px;
  height: 90px;
  background: #f3f7fb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(46, 162, 250, 0.08);
}
.device-img-ui {
  width: 156px;
  height: 134px;
  object-fit: contain;
  border-radius: 8px;
}
.device-name-ui {
  font-size: 16px;
  color: #333;
  text-align: center;
  margin-top: 10px;
  margin-left: -15px;
  font-weight: 500;
}
.monitor-grid-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-bottom: 24px;
  margin-top: 50px;
}
@media (max-width: 1440px) {
  .monitor-grid-5 {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
  .monitor-card-5 {
    min-width: 220px;
    height: 140px;
  }
  .card-title {
    font-size: 20px;
  }
  .card-value {
    font-size: 24px;
  }
}
@media (max-width: 1024px) {
  .monitor-grid-5 {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }
  .monitor-card-5 {
    min-width: 180px;
    height: 120px;
  }
  .card-title {
    font-size: 16px;
  }
  .card-value {
    font-size: 18px;
  }
  .card-icon-img {
    width: 32px;
    height: 32px;
  }
}
@media (max-width: 700px) {
  .monitor-grid-5 {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .monitor-card-5 {
    min-width: 120px;
    height: 90px;
  }
  .card-title {
    font-size: 14px;
  }
  .card-value {
    font-size: 14px;
  }
  .card-icon-img {
    width: 24px;
    height: 24px;
  }
}
@media (max-width: 1200px) {
  .device-card-ui {
    min-width: 320px;
    max-width: 100%;
  }
  .monitor-card-5 {
    min-width: 120px;
    max-width: 32%;
  }
}
@media (max-width: 900px) {
  .device-card-grid {
    flex-direction: column;
  }
  .device-card-ui {
    min-width: 90vw;
    max-width: 100%;
  }
  .monitor-grid-5 {
    flex-direction: column;
  }
  .monitor-card-5 {
    min-width: 90vw;
    max-width: 100%;
  }
}
.monitor-card-5 {
  height: 157px;
  display: flex;
  align-items: center;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(46, 162, 250, 0.08);
  background: #2ea2fa;
  padding: 0 24px;
  transition: box-shadow 0.2s;
}
.card-content-new {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  position: absolute;
  top: 18px;
  left: 0px;
}
.card-icon {
  width: 50px;
  height: 50px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #2ea2fa;
}
.card-icon-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}
.card-title {
  font-size: 24px;
  color: #fff;
  font-weight: 500;
  white-space: nowrap;
}
.card-value {
  position: absolute;
  right: 18px;
  bottom: 18px;
  font-size: 28px;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  white-space: nowrap;
}
</style>
